import { DeckDef } from "../types";

// Deck A — „Dlaczego to przełom". Krótka, rzeczowa prezentacja (~6–8 min) na spotkanie z decydentami.
// Każdy slajd ma notatki dla prezentującego (laicko + metafora).
export const whyDeck: DeckDef = {
  id: "why",
  slug: "dlaczego",
  title: "Dlaczego to przełom",
  subtitle: "Głosowania, którym nie trzeba ufać — wystarczy je sprawdzić",
  publisher: "Fundacja Potrafisz Polsko · lubbezposrednio.pl",
  estimatedMin: 7,
  ready: true,
  slides: [
    {
      id: "hook",
      tone: "brand",
      scene: "ballot-seal",
      logo: "/LBP_Logo_White.svg",
      title: "Wynik, którego nie da się *podważyć*",
      lead: "Każdy głos zapieczętowany na blockchainie — i jawnie weryfikowalny przez każdego.",
      durationSec: 40,
      notes:
        "Wejście spokojne, mocne. Jedno zdanie. „Pokażę Państwu system głosowań online, którego uczciwości nie trzeba brać na wiarę — można ją niezależnie zweryfikować”. Metafora przewodnia całości: zapieczętowana, przezroczysta urna."
    },
    {
      id: "problem",
      scene: "black-box",
      kicker: "Problem",
      title: "Dziś trzeba *zaufać* operatorowi",
      lead: "A wynik łatwo podważyć — i trudno udowodnić, że był uczciwy.",
      bullets: [
        "Głosowania online opierają się na zaufaniu do firmy, która je prowadzi.",
        "Brakuje twardego, publicznego dowodu, że nikt nie dosypał ani nie podmienił głosów.",
        "Podważony wynik = podważona decyzja i autorytet instytucji."
      ],
      durationSec: 60,
      notes:
        "Podkreśl: problemem nie jest technologia liczenia, tylko ZAUFANIE i DOWÓD. Dziś musimy wierzyć operatorowi na słowo. Przy ważnych decyzjach to za mało — wystarczy cień podejrzenia, by podważyć cały wynik."
    },
    {
      id: "idea",
      scene: "stamp-chain",
      kicker: "Nasza idea w jednym zdaniu",
      title: "Uczciwość *zapieczętowana* na blockchainie",
      lead: "Każdy głos zostawia trwały, publiczny ślad — który każdy może niezależnie sprawdzić.",
      terms: [
        { term: "blockchain", gloss: "niezmienialny, publiczny rejestr" },
        { term: "hash", gloss: "cyfrowy odcisk głosu" }
      ],
      durationSec: 50,
      notes:
        "Tu pada sedno. Metafora: blockchain = nienaruszalna, przezroczysta PIECZĘĆ na wyniku. Złamiesz pieczęć — od razu widać. Nie trzeba nam wierzyć: dowód jest publiczny i matematyczny."
    },
    {
      id: "pillars",
      kicker: "Trzy filary",
      title: "Dlaczego to naprawdę *przełom*",
      pillars: [
        {
          title: "Niezmienialność",
          text: "Nikt — nawet my — nie dosypie ani nie podmieni głosu bez śladu.",
          icon: "FiLock"
        },
        {
          title: "Tajność udowodniona",
          text: "Wiadomo, ŻE ktoś zagłosował, ale nie wiadomo JAK. Gwarantuje to matematyka (ZKP).",
          icon: "FiEyeOff"
        },
        {
          title: "Suwerenność",
          text: "Własny łańcuch Fundacji, otwarty kod, każdy może postawić węzeł i sprawdzić.",
          icon: "FiShield"
        }
      ],
      durationSec: 90,
      notes:
        "Trzy filary — po jednym zdaniu na każdy. (1) Niezmienialność = zapieczętowana urna. (2) Tajność = świadek, który potwierdza ważność głosu, ale nie patrzy w kartę. (3) Suwerenność = to NASZ rejestr, polski i niezależny, a kod jest otwarty, więc każdy może go skontrolować. Nie zwalniaj — to serce pitchu."
    },
    {
      id: "why-state",
      scene: "institution",
      kicker: "Co to daje Państwu",
      title: "Wiarygodność, której *nie da się podważyć*",
      bullets: [
        "Odporność na manipulację i na podważanie wyników — dowód jest publiczny.",
        "Wzmocniony autorytet instytucji organizującej głosowanie.",
        "Niezależność technologiczna — rozwiązanie polskie, nie zewnętrzny dostawca."
      ],
      durationSec: 70,
      notes:
        "Przełóż na język decydenta: mniej ryzyka politycznego (nikt skutecznie nie podważy wyniku), większa wiarygodność, suwerenność cyfrowa. To nie gadżet — to narzędzie budujące zaufanie do instytucji."
    },
    {
      id: "works",
      scene: "device-trio",
      kicker: "To nie koncept — to działa",
      title: "Gotowe i *uruchomione*",
      stats: [
        { value: "3", label: "platformy: web, iOS, Android" },
        { value: "3", label: "niezależne węzły łańcucha (zasada 2-z-3)" },
        { value: "1000", label: "transakcji w jednym bloku w testach" },
        { value: "100%", label: "wyniku weryfikowalne publicznie" }
      ],
      durationSec: 60,
      notes:
        "Pokaż, że to żywy produkt, nie prezentacja przyszłości. Web + iOS + Android, publiczny eksplorator łańcucha, łańcuch 3-węzłowy działający na żywo, przebadana skala. Liczby „wbiegają” — daj im chwilę wybrzmieć."
    },
    {
      id: "verify",
      scene: "verify-lights",
      kicker: "Każdy może sprawdzić",
      title: "Sprawdź sam, czy wynik *nie został zmieniony*",
      lead: "Jedno kliknięcie pokazuje wprost: zielone — wynik jest prawdziwy i nikt go nie ruszył, albo czerwone — ktoś go zmienił. Nie musisz nikomu wierzyć na słowo.",
      terms: [
        { term: "eksplorator", gloss: "publiczny podgląd łańcucha" },
        { term: "weryfikacja", gloss: "sprawdzenie zgodności z zapisem" }
      ],
      durationSec: 50,
      notes:
        "Metafora świateł: zielone = wynik zgodny z zapieczętowanym łańcuchem, czerwone = ktoś coś ruszył. To przenosi weryfikację z „uwierz nam” na „sprawdź sam”. Tu można wspomnieć o publicznym eksploratorze."
    },
    {
      id: "cta",
      tone: "brand",
      scene: "launch",
      kicker: "Następny krok",
      title: "Zróbmy wspólnie *pilotaż*",
      lead: "Pokażemy pełen obraz i przygotujemy wdrożenie pod konkretne potrzeby.",
      cta: "kontakt@potrafiszpolsko.pl · lubbezposrednio.pl",
      durationSec: 40,
      notes:
        "Zamknięcie: jasne wezwanie. Propozycja pilotażu / konsultacji społecznych / głosowania w instytucji. Zostaw kontakt na ekranie. Jeśli jest czas i zainteresowanie — przechodzimy do prezentacji szczegółowej (Deck B)."
    }
  ]
};
